<div class="main-container">
	<h3>
		<span>Deficiencies</span>
		<div [ngClass]="{'dont-allow': !allowDeficiencies}">
		<!--<button mat-icon-button class="text-action-button">
				<mat-icon>add</mat-icon>
				<span>Add</span>
			</button>-->
	
			<button mat-icon-button>
				<mat-icon>filter_list</mat-icon>
			</button>
		</div>
	</h3>
	<h5 class="account-name">
		{{userAccountInfoModel.accountName}}
	</h5>
	<ng-container *ngIf="!allowDeficiencies">
		<p class="empty-message-container red">This feature is not enabled for your setup.</p>
	</ng-container>
	<ng-container *ngIf="allowDeficiencies">
		<div class="items-list">
			<p class="empty-message-container" *ngIf="!deficiencies?.length">There are no deficiencies</p>
	
			<div class="items-container" *ngFor="let item of deficiencies" (click)="redirectToDeficiency(item)">
				<div class="items-details">
					<span class="deficiency-number" *ngIf="item.deficiencyNumber">
						#{{ item.deficiencyNumber }}
					</span>
	
					<span class="address" *ngIf="item.siteAddress">
						{{ item.siteAddress }}
					</span>
	
					<span class="comment" *ngIf="item.comment">
						{{ item.comment }}
					</span>
					<span class="deficiency-class" *ngIf="item.className">
						<span class="label">{{ item.classAlias || 'Class' }}:</span>
						{{ item.className }}
					</span>
					<span class="deficiency-type" *ngIf="item.typeName">
						<span class="label">{{ item.typeAlias || 'Type' }}:</span>
						{{ item.typeName }}
					</span>
					<span class="deficiency-subtype" *ngIf="item.subTypeName">
						<span class="label">{{ item.subTypeAlias || 'Subtype' }}:</span>
						{{ item.subTypeName }}
					</span>
	
					<span class="deficiency-standard-class" *ngIf="item.standardClassName">
						<span class="label">Standard Class:</span>
						{{ item.standardClassName }}
					</span>
					<span class="deficiency-standard-type" *ngIf="item.standardTypeName">
						<span class="label">Standard Type:</span>
						{{ item.standardTypeName }}
					</span>
					
					<span class="deficiency-floor" *ngIf="item.isFloorEnabled">
						<span class="label">Floor:</span> 
						{{ item.floor || 'n/a' }}
					</span>
					<span class="deficiency-room" *ngIf="item.isRoomEnabled">
						<span class="label">Room:</span> 
						{{ item.room || 'n/a' }}
					</span>
					<span class="deficiency-location" *ngIf="item.isLocationEnabled">
						<span class="label">Location:</span> 
						{{ item.location || 'n/a' }}
					</span>
	
					<span class="emergency">
						<span class="label">{{ item.emergencyAlias ? item.emergencyAlias : 'Emergency' }}:</span>
						{{ item.isEmergency ? 'YES' : 'NO' }}
					</span>
	
					<span class="generic-option" *ngIf="item.isGenericOptionEnabled">
						<span class="label">{{ item.genericOptionAlias ? item.genericOptionAlias : 'Generic Option' }}:</span>
						{{ item.genericOptionValue ? 'YES' : 'NO' }}
					</span>
	
					<span class="created-by-on">
						Submitted by {{ item.requestedBy }}
						on {{ moment(item.requestedOn).format('MM/DD/YYYY hh:mm A') }}
					</span>
	
					<span class="photo-count" *ngIf="!!item.photosCount">({{ item.photosCount }} {{
						item.photosCount > 1 ? 'photos' : 'photo' }})</span>
	
				</div>
			</div>
		</div>
	</ng-container>
</div>